module.exports = __webpack_public_path__ + "img/FloweLogotype_Blue_M.0ce81ec6.png";